import React, { useEffect, useState, useRef } from 'react'
import { CircularProgress, Button } from '@mui/material';
import { visualControlStyles } from '../../styles/Home'
//import { useMediapipe } from '../../api/MediapipeHandsPose';
import { useMediapipe } from '../../api/MediapipeHolistic';
import { pVisualControl, pVisualizerControl } from '../../utils/parameters';
import { red, green, indigo } from '@mui/material/colors';


export const btns_home_positions_arr_default=[
    {   label: pVisualControl.Btn_Grabar.label,
        id_action: pVisualControl.Btn_Grabar.id_action,
        position :{
            top: pVisualControl.Btn_Grabar.top,
            left: pVisualControl.Btn_Grabar.left, 
            width: pVisualControl.Btn_Grabar.width, 
            height : pVisualControl.Btn_Grabar.height,
        },
        showNext : pVisualControl.Btn_Grabar.showNext,
        repeat : pVisualControl.Btn_Grabar.repeat,
        counter_progress: 0,
        visible: true   },
    {   label: pVisualControl.Btn_Repetir.label,
        id_action: pVisualControl.Btn_Repetir.id_action,
        position :{
            top: pVisualControl.Btn_Repetir.top,
            left: pVisualControl.Btn_Repetir.left, 
            width: pVisualControl.Btn_Repetir.width, 
            height : pVisualControl.Btn_Repetir.height,
        },
        showNext : pVisualControl.Btn_Repetir.showNext,
        repeat : pVisualControl.Btn_Repetir.repeat,
        counter_progress: 0,
        visible: false  },
    {   label: pVisualControl.Btn_Enviar.label,
        id_action: pVisualControl.Btn_Enviar.id_action,
        position :{
            top: pVisualControl.Btn_Enviar.top,
            left: pVisualControl.Btn_Enviar.left, 
            width: pVisualControl.Btn_Enviar.width, 
            height : pVisualControl.Btn_Enviar.height,
        },
        showNext : pVisualControl.Btn_Enviar.showNext,
        repeat : pVisualControl.Btn_Enviar.repeat,
        counter_progress: 0,
        visible: false  },
    {   label: pVisualControl.Btn_Signo_Definicion.label,
        id_action: pVisualControl.Btn_Signo_Definicion.id_action,
        position :{
            top: pVisualControl.Btn_Signo_Definicion.top,
            left: pVisualControl.Btn_Signo_Definicion.left, 
            width: pVisualControl.Btn_Signo_Definicion.width, 
            height : pVisualControl.Btn_Signo_Definicion.height
        },
        showNext : pVisualControl.Btn_Signo_Definicion.showNext,
        repeat : pVisualControl.Btn_Signo_Definicion.repeat,
        counter_progress: 0,
        visible: false  },
    {   label: pVisualControl.Btn_Siguiente.label,
        id_action: pVisualControl.Btn_Siguiente.id_action,
        position :{
            top: pVisualControl.Btn_Siguiente.top,
            left: pVisualControl.Btn_Siguiente.left, 
            width: pVisualControl.Btn_Siguiente.width, 
            height : pVisualControl.Btn_Siguiente.height,
        },
        showNext : pVisualControl.Btn_Siguiente.showNext,
        repeat : pVisualControl.Btn_Siguiente.repeat,
        counter_progress: 0,
        visible: false  },
    {   label: pVisualControl.Btn_OK.label,
        id_action: pVisualControl.Btn_OK.id_action,
        position :{
            top: pVisualControl.Btn_OK.top,
            left: pVisualControl.Btn_OK.left, 
            width: pVisualControl.Btn_OK.width, 
            height : pVisualControl.Btn_OK.height,
        },
        showNext : pVisualControl.Btn_OK.showNext,
        repeat : pVisualControl.Btn_OK.repeat,
        counter_progress: 0,
        visible: false  }
]

export const btns_visualizer_positions_arr_default=[

    {   label: pVisualizerControl.Btn_Atras.label,
        id_action: pVisualizerControl.Btn_Atras.id_action,
        position :{
            top: pVisualizerControl.Btn_Atras.top,
            left: pVisualizerControl.Btn_Atras.left, 
            width: pVisualizerControl.Btn_Atras.width, 
            height : pVisualizerControl.Btn_Atras.height
        },
        showNext : pVisualizerControl.Btn_Atras.showNext,
        repeat : pVisualizerControl.Btn_Atras.repeat,
        counter_progress: 0,
        visible: true  },
    {   label: pVisualizerControl.Btn_Siguiente.label,
        id_action: pVisualizerControl.Btn_Siguiente.id_action,
        position :{
            top: pVisualizerControl.Btn_Siguiente.top,
            left: pVisualizerControl.Btn_Siguiente.left, 
            width: pVisualizerControl.Btn_Siguiente.width, 
            height : pVisualizerControl.Btn_Siguiente.height
        },
        showNext : pVisualizerControl.Btn_Siguiente.showNext,
        repeat : pVisualizerControl.Btn_Siguiente.repeat,
        counter_progress: 0,
        visible: true  },
    {   label: pVisualizerControl.Btn_Aleatorio.label,
        id_action: pVisualizerControl.Btn_Aleatorio.id_action,
        position :{
            top: pVisualizerControl.Btn_Aleatorio.top,
            left: pVisualizerControl.Btn_Aleatorio.left, 
            width: pVisualizerControl.Btn_Aleatorio.width, 
            height : pVisualizerControl.Btn_Aleatorio.height
        },
        showNext : pVisualizerControl.Btn_Aleatorio.showNext,
        repeat : pVisualizerControl.Btn_Aleatorio.repeat,
        counter_progress: 0,
        visible: true  },
    {   label: pVisualizerControl.Btn_Abrir_Dialog.label,
        id_action: pVisualizerControl.Btn_Abrir_Dialog.id_action,
        position :{
            top: pVisualizerControl.Btn_Abrir_Dialog.top,
            left: pVisualizerControl.Btn_Abrir_Dialog.left, 
            width: pVisualizerControl.Btn_Abrir_Dialog.width, 
            height : pVisualizerControl.Btn_Abrir_Dialog.height
        },
        showNext : pVisualizerControl.Btn_Abrir_Dialog.showNext,
        repeat : pVisualizerControl.Btn_Abrir_Dialog.repeat,
        counter_progress: 0,
        visible: true  },
    {   label: pVisualizerControl.Btn_Signo_Definicion.label,
        id_action: pVisualizerControl.Btn_Signo_Definicion.id_action,
        position :{
            top: pVisualizerControl.Btn_Signo_Definicion.top,
            left: pVisualizerControl.Btn_Signo_Definicion.left, 
            width: pVisualizerControl.Btn_Signo_Definicion.width, 
            height : pVisualizerControl.Btn_Signo_Definicion.height
        },
        showNext : pVisualizerControl.Btn_Signo_Definicion.showNext,
        repeat : pVisualizerControl.Btn_Signo_Definicion.repeat,
        counter_progress: 0,
        visible: false  },
    {   label: pVisualizerControl.Btn_OK.label,
        id_action: pVisualizerControl.Btn_OK.id_action,
        position :{
            top: pVisualizerControl.Btn_OK.top,
            left: pVisualizerControl.Btn_OK.left, 
            width: pVisualizerControl.Btn_OK.width, 
            height : pVisualizerControl.Btn_OK.height
        },
        showNext : pVisualizerControl.Btn_OK.showNext,
        repeat : pVisualizerControl.Btn_OK.repeat,
        counter_progress: 0,
        visible: false  },
]



function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    
    useEffect(() => {
        let id = setInterval(() => {
            savedCallback.current();
        }, delay);
        return () => {
            // console.log('STOP INTERVAL')
            clearInterval(id);
        }
    }, [delay]);
}

export function VisualControl(props) {
    const { videoref, setVisualControlAction, btns_arr } = props
    const cstyles = visualControlStyles();
    const { get_keypoints_visual_control } = useMediapipe();
    const [btns_positions_arr, setBtns_positions_arr] = useState(btns_arr);
    const [iteration, setIteration] = useState(0);

    const interval_value = 250;
    const increase_value = 19;
    // const styles = cardStyles();

    // COLORS
    const color_btn_deactivate = red[300];
    const color_btn_activate = green[300]
    const color_circular_progress = indigo[900]

    useEffect(() => {
        // console.log('USE EFFECT')
        // console.log(btns_arr)
        if (btns_arr !== undefined) {
            setBtns_positions_arr(btns_arr)
        }
    },[btns_arr])


    useInterval(() => {
        getKeypointsResults()
    }, interval_value);

    function convertInfoPoseRef(value){
        // Convert 10% to 0.1
        return Number(value.slice(0, -1))/100;
    }
    
    function checkBtn(pose, btn_info){
        const x_ref = convertInfoPoseRef(btn_info.position.left)
        const w_ref = convertInfoPoseRef(btn_info.position.width)
        const y_ref = convertInfoPoseRef(btn_info.position.top)
        const h_ref = convertInfoPoseRef(btn_info.position.height)

        const x_in = 1- pose.x
        const y_in = pose.y

        // console.log('x_ref: '+x_ref+ '& y_ref: '+ y_ref )
        // console.log('x_in: '+x_in+ '& y_in: '+ y_in )

        if (((x_in >= x_ref) && (x_in <= x_ref + w_ref)) && ((y_in >= y_ref) && (y_in <= y_ref + h_ref))) {
            return true;
        }else{
            return false;
        }
    }

    function checkAllBtns(pose){
        for (const btn_idx in btns_positions_arr) {
            if (btns_positions_arr[btn_idx].visible === true){
                if (checkBtn(pose, btns_positions_arr[btn_idx])){
                    return btn_idx
                }
            }
        }
        return -1
    }

    function getKeypointsResults(){
        if (videoref.current !== null) {
            const pose_data = get_keypoints_visual_control()
            let btn_selected = -1
            for (const pose_idx of pose_data){
                try{
                    if(btn_selected < 0) {
                        btn_selected = checkAllBtns(pose_idx)
                    }
                }catch{
                }
            }
            update_progress_btns ( btn_selected )
        }
    }

    function resetCounters(btn_selected){
        for (const btn_idx in btns_positions_arr) {
            if (btn_idx !== btn_selected){
                btns_positions_arr[btn_idx].counter_progress = 0
                setBtns_positions_arr(btns_positions_arr)
            }
        }
    }

    function activated_button(btn_selected){       
        
        setVisualControlAction (btns_positions_arr[btn_selected].id_action)
        updateButtonsVisibility(btn_selected)
        // console.log('ACTIVATED BUTTON: '+btn_selected)

        if (btns_positions_arr[btn_selected].repeat === true){
            resetCounters(-1) // Reset counters
        }
    }

    function updateButtonsVisibility(btn_selected){
        btns_positions_arr[btn_selected].showNext.forEach(function (value, i) {
            btns_positions_arr[i].visible = value
        });
    }

    function increaseCounter(btn_selected){
        if (btns_positions_arr[btn_selected].counter_progress < 100){
            let new_value_progress = btns_positions_arr[btn_selected].counter_progress + increase_value
            if (new_value_progress > 100){
                new_value_progress = 100 
            }
            btns_positions_arr[btn_selected].counter_progress = new_value_progress
            setBtns_positions_arr(btns_positions_arr)
            if (btns_positions_arr[btn_selected].counter_progress >= 100) {
                // console.log('activado: '+btns_positions_arr[btn_selected].label)
                activated_button(btn_selected)
            }
        }
    }

    function update_progress_btns(btn_selected){
        if (btn_selected < 0){
            resetCounters(btn_selected)
        }else{
            resetCounters(btn_selected)
            increaseCounter(btn_selected)
        }
        setIteration (iteration + 1)
        //console.log('update_progress_btns: '+ btn_selected)
    }

    function getColor(counter_progress){
        return counter_progress > 0 ? color_btn_activate : color_btn_deactivate
    }

    return (
        <>
            {btns_positions_arr.map(btn => {
                const { label, position, counter_progress, visible } = btn;
                    return(
                        visible 
                            ?   <Button className={cstyles.cButtons} style={{ backgroundColor: getColor(counter_progress), color: '#FFFFFF', position: 'absolute', top: position.top , left: position.left, width: position.width, height : position.height, zIndex: 20}}
                                    startIcon={<CircularProgress style={{'color': color_circular_progress}} variant="determinate" size={30} thickness={10} value={counter_progress} />} 
                                    size="large" 
                                    variant="contained" 
                                    color= {counter_progress > 0 ? "success" : "error"}
                                    >
                                        
                                    {label}
                                </Button>
                            :   <></>
                        )
                    }
                )
            }
        </>
    )
}